import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CmsBannerCarouselComponent } from '../../../core/model';

@Component({
  selector: 'py-banner-collection',
  templateUrl: './banner-collection.component.html',
  styleUrls: ['./banner-collection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BannerCollectionComponent implements OnInit {
  styleClasses$: Observable<string>;
  banners$: Observable<string>;
  bannerCollectionComponentType$: Observable<string>;

  constructor(public cmsComponent: CmsComponentData<CmsBannerCarouselComponent>) {}

  ngOnInit(): void {
    this.banners$ = this.cmsComponent.data$.pipe(map((d) => d?.banners ?? ''));
    this.styleClasses$ = this.cmsComponent.data$.pipe(
      filter((d) => !!d?.styleClasses?.includes),
      map((d) => d?.styleClasses)
    );
  }

  getRandomUid(bannerString?: string): string {
    const banners = bannerString?.split(' ') || [];
    return banners[Math.floor(Math.random() * banners.length)];
  }
}
